"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _regeneratorValues2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regeneratorValues.js"));
var _interopRequireWildcard2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _log = require("@/utils/log");
var _training = require("@/api/training");
var _lodash = _interopRequireDefault(require("lodash"));
var _cookie = require("@/utils/cookie");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import moment from 'moment'
// import { writeGaEvent } from '@/utils/ga'
// import { parseTime } from '@/utils'
var _default = exports.default = {
  name: 'ILTAttendanceReport',
  data: function data() {
    return {
      tableLoading: true,
      participantList: [],
      trainingId: '',
      trainingTitle: '',
      trainingSessions: [],
      teams: [],
      userTrainings: [],
      autoWidth: true,
      bookType: 'xlsx',
      exportDisable: true
    };
  },
  created: function created() {
    var _this = this;
    return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      var tid, token;
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            tid = typeof _this.$route.params.id === 'undefined' ? '' : _this.$route.params.id;
            token = (0, _cookie.getCookie)('ACCESS_TOKEN');
            _context.n = 1;
            return _this.getTraining(token, tid);
          case 1:
            _context.n = 2;
            return _this.getParticipantAndUserTraining(token, tid);
          case 2:
            _context.n = 3;
            return _this.buildReport(_this.trainingSessions, _this.teams, _this.userTrainings);
          case 3:
            _this.tableLoading = false;
            _this.exportDisable = false;
          case 4:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    checkPermission: _permission.default,
    exportExcel: function exportExcel() {
      var _this2 = this;
      var tid = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/vendor/Export2Excel'));
      }).then(function (excel) {
        var tHeader = ['ILT/VILT Session ID', 'Session Title', 'Event Timezone', 'Event Start Time (Local)', 'Event Start Time (UTC)', 'User Name', 'Email', 'Company', 'Job Title', 'Checkin Time (Local)', 'Checkin Time (UTC)'];

        // const data = this.formatJson(filterVal, list)
        var xdata = _this2.buildExcelData();
        excel.export_json_to_excel({
          header: tHeader,
          data: xdata,
          filename: 'ILT Attendance-' + tid,
          autoWidth: _this2.autoWidth,
          bookType: _this2.bookType
        });
      });
    },
    getTrainingParticipant: function getTrainingParticipant() {
      var _this3 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var tid, token;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              tid = typeof _this3.$route.params.id === 'undefined' ? '' : _this3.$route.params.id;
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              _this3.tableLoading = true;
              (0, _training.getTrainingTeams)(token, tid).then(/*#__PURE__*/function () {
                var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(response) {
                  var members;
                  return (0, _regenerator2.default)().w(function (_context2) {
                    while (1) switch (_context2.n) {
                      case 0:
                        _this3.trainingId = tid;
                        // this.participantList = response.data.rows[0].members
                        members = response.data.rows[0].members;
                        _context2.n = 1;
                        return _this3.getAttendance(token, tid, members);
                      case 1:
                        _this3.tableLoading = false;
                        _this3.exportDisable = false;
                      case 2:
                        return _context2.a(2);
                    }
                  }, _callee2);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()).catch(function (error) {
                (0, _log.showDebugLog)('ILT-AttendanceReport-error', error);
                _this3.tableLoading = false;
                (0, _log.displayPopupMessage)(error, 'error');
                // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response })
              });
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getAttendance: function getAttendance(token, tid, members) {
      var _this4 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var _loop, i;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _loop = /*#__PURE__*/(0, _regenerator2.default)().m(function _loop(i) {
                return (0, _regenerator2.default)().w(function (_context4) {
                  while (1) switch (_context4.n) {
                    case 0:
                      _context4.n = 1;
                      return (0, _training.getUserTraining)(token, members[i].uuid).then(function (response) {
                        // only return last 100 user training
                        var userTrainings = response.data.rows;
                        var userTraining = _lodash.default.find(userTrainings, function (t) {
                          return t.training === tid;
                        });

                        // console.log('userTraining', userTraining)
                        members[i].trainingTitle = userTraining && userTraining.trainingTitle ? userTraining.trainingTitle : '-';
                        members[i].isCheckin = userTraining ? userTraining.onSiteCheckedIn : '-';
                        members[i].checkinTime = userTraining && userTraining.onSiteCheckedInDateTime ? userTraining.onSiteCheckedInDateTime : '-';
                      });
                    case 1:
                      return _context4.a(2);
                  }
                }, _loop);
              });
              i = 0;
            case 1:
              if (!(i < members.length)) {
                _context5.n = 3;
                break;
              }
              return _context5.d((0, _regeneratorValues2.default)(_loop(i)), 2);
            case 2:
              i++;
              _context5.n = 1;
              break;
            case 3:
              _this4.participantList = members;
            case 4:
              return _context5.a(2);
          }
        }, _callee4);
      }))();
    },
    getTraining: function getTraining(token, tid) {
      var _this5 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5() {
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return (0, _training.getTrainingById)(token, tid).then(function (response) {
                _this5.trainingId = tid;
                _this5.trainingTitle = response.data.title;
                _this5.trainingSessions = response.data.sessions;
                // console.log('getTraining', response.data.sessions)
              }).catch(function (error) {
                _this5.trainingId = tid;
                _this5.trainingTitle = '';
                _this5.trainingSessions = [];
                (0, _log.showDebugLog)('ILT-error', error);
              });
            case 1:
              return _context6.a(2);
          }
        }, _callee5);
      }))();
    },
    getParticipantAndUserTraining: function getParticipantAndUserTraining(token, tid) {
      var _this6 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6() {
        return (0, _regenerator2.default)().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return (0, _training.getTeamAndUserTraining)(token, tid).then(function (response) {
                _this6.teams = response.data.teams[0].members;
                _this6.userTrainings = response.data.userTrainings;
                // console.log('team and userTraining', response.data)
              }).catch(function (error) {
                _this6.teams = [];
                _this6.userTrainings = [];
                (0, _log.showDebugLog)('ILT-Team-error', error);
              });
            case 1:
              return _context7.a(2);
          }
        }, _callee6);
      }))();
    },
    buildReport: function buildReport(trainingSessions, teams, userTrainings) {
      var _this7 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee7() {
        var i, j, checkInTimeUtc, checkInTimeLocal, record;
        return (0, _regenerator2.default)().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              for (i = 0; i < trainingSessions.length; i++) {
                if (trainingSessions[i].allowCheckin) {
                  for (j = 0; j < teams.length; j++) {
                    checkInTimeUtc = _this7.getCheckInTime(teams[j].uuid, trainingSessions[i].id, userTrainings);
                    checkInTimeLocal = checkInTimeUtc ? (0, _momentTimezone.default)(checkInTimeUtc).tz(trainingSessions[i].start.timezone).format('YYYY-MM-DD HH:mm:ss') : '';
                    record = {
                      sessionId: trainingSessions[i].id,
                      sessionTitle: trainingSessions[i].title,
                      eventStartTime: trainingSessions[i].start.utc,
                      eventTimezone: trainingSessions[i].start.timezone,
                      eventLocalStartTime: (0, _momentTimezone.default)(trainingSessions[i].start.utc).tz(trainingSessions[i].start.timezone).format('YYYY-MM-DD HH:mm:ss'),
                      email: teams[j].email,
                      name: "".concat(teams[j].givenName, " ").concat(teams[j].familyName),
                      jobTitle: teams[j].jobTitle,
                      company: teams[j].orgName,
                      checkinTimeLocal: checkInTimeLocal,
                      checkinTime: checkInTimeUtc
                    };
                    _this7.participantList.push(record);
                  }
                }
              }
            case 1:
              return _context8.a(2);
          }
        }, _callee7);
      }))();
    },
    getCheckInTime: function getCheckInTime(uuid, sessionId, userTrainings) {
      var session;
      var checkinTime = '';
      var ut = _lodash.default.find(userTrainings, function (o) {
        return o.user === uuid;
      });
      if (ut) {
        session = _lodash.default.find(ut.sessions, function (s) {
          return s.sessionId === sessionId;
        });
        if (session) {
          checkinTime = session.checkedInDateTime ? session.checkedInDateTime : '';
        }
      }
      return checkinTime;
    },
    buildExcelData: function buildExcelData() {
      var excelData = [];
      for (var i = 0; i < this.participantList.length; i++) {
        excelData.push([_lodash.default.get(this.participantList[i], 'sessionId', ''), _lodash.default.get(this.participantList[i], 'sessionTitle', '').toString(), _lodash.default.get(this.participantList[i], 'eventTimezone', '').toString(), _lodash.default.get(this.participantList[i], 'eventLocalStartTime', '').toString(), _lodash.default.get(this.participantList[i], 'eventStartTime', '').toString(), _lodash.default.get(this.participantList[i], 'name', ''), _lodash.default.get(this.participantList[i], 'email', ''), _lodash.default.get(this.participantList[i], 'company', ''), _lodash.default.get(this.participantList[i], 'jobTitle', ''), _lodash.default.get(this.participantList[i], 'checkinTimeLocal', '').toString(), _lodash.default.get(this.participantList[i], 'checkinTime', '').toString()]);
      }
      return excelData;
    }
  }
};